import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setTradeIn } from '../actions'
import Defaults from './Defaults'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(Defaults)
